var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityNews = function SvgSecurityNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#security-news_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 0 1.75 2.616v6.153a5.25 5.25 0 1 0 10.5 0V2.616zm2.988 11.95L7 10.461v.975l2.203 1.098a4.377 4.377 0 0 1-6.578-3.765V3.154L7 .975l4.375 2.18v1.64L7 2.615v.975l4.375 2.18v1.64L7 5.23v.976l4.375 2.179v.384c0 .398-.054.793-.162 1.176L7 7.846v.975l3.892 1.939c-.231.445-.537.848-.904 1.19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "security-news_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgSecurityNews;